import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const services = [
  {
    icon: "ti-briefcase",
    title:
      "Microsoft Dynamics 365 Finance & Operations Implementation & Support",
    desc:
      "We deliver end-to-end implementation services to ensure a smooth and successful ERP deployment.",
    points: [
      "Full lifecycle D365 F&O implementation",
      "Business process analysis and system design",
      "Configuration and deployment",
      "Data migration and integration",
      "User training and go-live support",
      "Post-implementation support and maintenance",
      "Performance optimization and system health monitoring",
    ],
  },
  {
    icon: "ti-user",
    title: "Microsoft Dynamics 365 F&O Customization",
    desc:
      "Every business is unique. We customize D365 F&O to match your exact operational requirements.",
    points: [
      "Custom forms, workflows, and business logic",
      "Automation of manual processes",
      "Custom modules and extensions",
      "Integration with third-party systems",
      "Reports and document customization",
      "Performance optimization",
    ],
  },
  {
    icon: "ti-bar-chart",
    title: "Power BI Dashboards & Advanced Analytics",
    desc:
      "Turn your D365 F&O data into actionable insights with powerful Power BI dashboards.",
    points: [
      "Executive dashboards",
      "Financial performance dashboards",
      "Inventory and supply chain analytics",
      "Production and manufacturing dashboards",
      "Sales and operational analytics",
      "Real-time KPI monitoring",
    ],
  },
  {
    icon: "ti-world",
    title: "Custom Applications & Mobile Solutions",
    desc:
      "We develop modern web and mobile applications that integrate seamlessly with D365 F&O or operate independently.",
    points: [
      "Shopfloor execution systems",
      "Field service mobile applications",
      "Commissioning and project execution apps",
      "Warehouse and inventory mobile solutions",
      "Quality control applications",
      "Standalone or ERP-integrated enterprise apps",
    ],
  },
];

const Services = () => {

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="main-wrapper">
      
      <Navbar transparent />

      <PageTitle title="Our Services" />

      {/* ===== DETAILED SERVICES ===== */}
      <section className="md bg-light-grey">
        <div className="container lg-container">
          {services.map((svc, idx) => (
            <div className="service-detail-row mb-5 p-4 bg-white rounded shadow-sm" key={idx}>
              <div className="row align-items-start">

                {/* LEFT ICON */}
                <div className="col-md-2 col-sm-3 text-center">
                  <div className="service-icon-wrap">
                    <i className={`${svc.icon} text-white`}></i>
                  </div>
                </div>

                {/* RIGHT CONTENT */}
                <div className="col-md-10 col-sm-9">
                  <h4 className="font-weight-700 mb-3">{svc.title}</h4>
                  <p className="mb-3">{svc.desc}</p>

                  <ul className="service-points ps-0">
                    {svc.points.map((point, i) => (
                      <li key={i}>
                        <i className="fas fa-check text-primary me-2"></i>
                        {point}
                      </li>
                    ))}
                  </ul>
                </div>

              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ===== IMPLEMENTATION APPROACH ===== */}
      <section className="md">
        <div className="container lg-container">

          <div className="section-heading2 text-center mb-5">
            <span className="alt-font">Our Approach</span>
            <h2>Our ERP Implementation Methodology</h2>
            <p className="w-80 mx-auto">
              We follow a structured, proven methodology to ensure successful ERP
              implementation with minimal disruption and maximum business value.
            </p>
          </div>

          <div className="row">

            {[
              "Understand Business Processes",
              "AS-IS & TO-BE Process Alignment",
              "Design Optimized ERP Solution",
              "System Implementation & Configuration",
              "Customization & Integration",
              "Analytics & Reporting",
              "Ongoing Support & Enhancements",
            ].map((step, i) => (
              <div className="col-md-6 col-lg-4 mb-4" key={i}>
                <div className="card border-0 shadow-sm h-100 p-4">
                  <div className="text-primary font-weight-700 mb-2">
                    Step {i + 1}
                  </div>
                  <h5 className="mb-0">{step}</h5>
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="p-0">
          <div className="container lg-container">
              <div className="parallax text-center cover-background p-2-0 p-sm-2-8 p-lg-8 p-xl-10 wow fadeInUp primary-overlay-180 rounded z-index-9" 
              data-wow-delay=".2s" data-overlay-dark="9" data-background="/img/bg/footer-bg.jpg" 
              style={{backgroundImage: 'url(/img/banner/header-bg.png)', visibility: 'visible', animationDelay: '0.2s',
                 animationName: 'fadeInUp' }}>

                  <div className="position-relative" style={{ zIndex: 1 }}>
                      <h2 className="mb-4 text-white">Ready to Transform Your ERP Landscape?</h2>
                      <p className="w-95 w-md-80 w-lg-65 w-xl-50 mx-auto text-white mb-4">
                        Speak with our Dynamics 365 experts to discuss your business
                        requirements and discover how Source-ERP can accelerate your
                        digital transformation journey.</p>
                      <Link to="/contact" className="butn style-two">Contact us</Link>
                  </div>

              </div>
          </div>
      </section>      

      <Footer />
    </div>
  );
};

export default Services;
